'use strict';

import React from 'react'

let app = window.app;

export default class ModalContent extends React.Component
{
	stopPropagation (e)
	{
		e.stopPropagation();

		app.emit('documentClick');
	}

	render ()
	{
		const component = this, props = this.props;

		var close_btn, spam_report;

		if (!props.hide_close)
		{
			close_btn =
			(
				<div className="c-dialog__buttons">
					<button type="button" className="c-btn c-dialog__cancel"
						onClick={ props.onClose }>
						Fermer
					</button>
				</div>
			);
		}

		if (props.type === 'conversation' || props.type === 'spam-conversation' )
		{
			spam_report =
			(
				<button className={ 'o-modal__action' +
					(props.type === 'spam-conversation' ? ' o-modal__action--spam' : '') }
					onClick={ props.onAction } key={ 1 }>
					<svg className="o-svg-icon o-svg-icon--phone o-modal__action_icon">
						<use xlinkHref="/images/icons.svg#svg-icon-phone"></use>
					</svg>

					<div className="o-modal__action-txt" key={ 2 }>
						{ props.type === 'conversation' ?
							'Signaler l’expéditeur comme SPAM' : 'Retirer cet expéditeur de la liste de SPAM' }
					</div>
				</button>
			);
		}

		const header = props.invisible !== true ?
		(
			<header className="o-modal__header u-no-select">

				<div className="o-modal__header-txt">
					{ props.title || 'Fenêtre contextuelle' }
				</div>

				<button className="o-modal__close"
					onClick={ props.onClose }
					onMouseDown={ function (e) { e.stopPropagation(); } }>
					Fermer
				</button>
			</header>
		)
		: undefined;

		var output =
		(
			<div className="o-modal__content" onMouseDown={ props.onClose } >

				<div className="o-modal__content-wrapper">

					<div className="o-modal__dialog"
						onMouseDown={ component.stopPropagation }>

						{ header }

						<div className="o-modal__body">

							{ props.children }

							{ close_btn }

							{ spam_report }

						</div>

					</div>

				</div>

			</div>
		);

		return output;
	}
}